import React from "react";
import "./index.scss";
import MdaeTooltip from "../tooltip";
import { TOGGLE_COPY_TEXT_TOOLTIP } from "../../../app/reducers/appReducer";
import { useDispatch } from "react-redux";
import MdaeButton from "../button";

export const CopyTextTooltip = () => {
  return (
    <MdaeTooltip
      id="pnlCopyTextTooltip"
      hideOnOutsideClick
      deferRendering={false}
      mdaeDataUpdaterConfig={[
        {
          actionType: TOGGLE_COPY_TEXT_TOOLTIP,
          reducerName: "appReducer",
          widgetOptionBindings: {
            visible: "copyTextTooltipConfig.isCopyTextTooltipVisible",
            target: "copyTextTooltipConfig.copyTextTooltipTarget",
          },
        },
      ]}
    >
      <div className="copy-text-tooltip">Copied!</div>
    </MdaeTooltip>
  );
};
interface IMdaeCopyTextProps {
  textToCopy: string;
  className?: string;
}
const MdaeCopyText: React.FC<IMdaeCopyTextProps> = (props) => {
  const dispatch = useDispatch();
  const toggleCopyTextTooltipVisible = (target) => {
    dispatch({
      type: TOGGLE_COPY_TEXT_TOOLTIP,
      data: {
        isCopyTextTooltipVisible: true,
        copyTextTooltipTarget: target,
      },
    });
  };
  return (
      <MdaeButton
        id="copyText"
        role="dxButton"
        stylingMode="text"
        className={props.className ? props.className : "copy-text copy-action-icon"}
        onClick={(e) => {                          
          const bodyObj = document.getElementsByTagName("body")[0];
          const tempInput: any = document.createElement("INPUT");
          tempInput.setSelectionRange(0, 99999);
          tempInput.setAttribute("value", props.textToCopy);
          bodyObj.appendChild(tempInput);
          navigator.clipboard.writeText(tempInput.value);
          bodyObj.removeChild(tempInput);
          toggleCopyTextTooltipVisible(e.element);
        }}
      />
  );
};
export default MdaeCopyText;
